import http from "@/utils/http";

// 根据班级分页查询课程安排
export function getLessons(data) {
  return http({
    url: "/lessons" + data,
    method: "GET"
  });
}

// 添加课程安排
export function addLessons(data) {
  return http({
    url: "/lesson/bind/course",
    method: "POST",
    data
  });
}

// 跳过课程安排（临时放弃本次课程安排）
export function cancelLessons(data) {
  return http({
    url: "/lesson/skip?lessonid=" + data,
    method: "POST"
  });
}

// 恢复课程安排 （恢复跳过的课程）
export function skipLessons(data) {
  return http({
    url: "/lesson/skip/cancel?lessonid=" + data,
    method: "POST"
  });
}

// 添加排课计划
export function addPlan(data) {
  return http({
    url: "/lesson/plan/add",
    method: "POST",
    data
  });
}

// 根据班级分页查询排课计划
export function getClassPlan(data) {
  return http({
    url: "/lesson/plans?classid=" + data,
    method: "GET"
  });
}

// 删除排课计划
export function removePlan(data) {
  return http({
    url: "/lesson/plan/delete?planid=" + data,
    method: "POST"
  });
}

// 暂停排课计划
export function stopPlan(data) {
  return http({
    url: "/lesson/plan/frozen?planid=" + data,
    method: "POST"
  });
}

// 修改排课计划-指定日期
export function resetPlan(id, data) {
  return http({
    url: "/lesson/plan/update/" + id,
    method: "POST",
    data
  });
}

// 暂停/冻结排课计划
export function suspansionPlan(data) {
  return http({
    url: "/lesson/plan/frozen?planid=" + data,
    method: "POST"
  });
}

// 激活课程计划
export function activePlan(data) {
  return http({
    url: "/lesson/plan/active?planid=" + data,
    method: "POST"
  });
}
